var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0F77A76F-5C18-4F5E-8710-AACD89D41F3A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.677033,11 L6.85078106,11 L10.2040022,13.6825769 L9.03093304,16.6152498 L12,14.8338096 L14.969067,16.6152498 L13.7959978,13.6825769 L17.1492189,11 L13.322967,11 L12,7.6925824 L10.677033,11 Z M9.32296704,9 L12,2.3074176 L14.677033,9 L22.8507811,9 L16.2040022,14.3174231 L19.030933,21.3847502 L12,17.1661904 L4.96906696,21.3847502 L7.7959978,14.3174231 L1.14921894,9 L9.32296704,9 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style-guide",
    transform: "translate(-1110.000000, -10777.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(60.000000, 10295.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1038.000000, 480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_star",
    transform: "translate(11.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#191919",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStar);
export default __webpack_public_path__ + "static/media/ico_star.96293583af5f39578ad5e8115eb94cf3.svg";
export { ForwardRef as ReactComponent };